import { EMPTY_OBJECT } from '../../../utils/object.esm.js';

function computeWidth(refElement, value) {
  var padding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;
  var retVal = EMPTY_OBJECT;
  // eslint-disable-next-line no-console
  // console.log(`--- computeWidth value: ${value} ----`)
  if (refElement && value) {
    // Create a div element
    var fakeEle = document.createElement('div');

    // Hide it completely
    fakeEle.style.position = 'absolute';
    fakeEle.style.top = '0';
    fakeEle.style.left = '-9999px';
    fakeEle.style.overflow = 'hidden';
    fakeEle.style.visibility = 'hidden';
    fakeEle.style.whiteSpace = 'nowrap';
    fakeEle.style.height = '0';

    // Get the styles
    var styles = window.getComputedStyle(refElement);

    // Copy font styles from the textbox
    fakeEle.style.fontFamily = styles.fontFamily;
    fakeEle.style.fontSize = styles.fontSize;
    fakeEle.style.fontStyle = styles.fontStyle;
    fakeEle.style.fontWeight = styles.fontWeight;
    fakeEle.style.letterSpacing = styles.letterSpacing;
    fakeEle.style.textTransform = styles.textTransform;
    fakeEle.style.borderLeftWidth = styles.borderLeftWidth;
    fakeEle.style.borderRightWidth = styles.borderRightWidth;
    fakeEle.style.paddingLeft = styles.paddingLeft;
    fakeEle.style.paddingRight = styles.paddingRight;

    // Append the fake element to `body`
    document.body.appendChild(fakeEle);
    fakeEle.innerHTML = value.replace(/\s/g, '&' + 'nbsp;');
    retVal = {
      width: "".concat(fakeEle.clientWidth + padding, "px")
    };
    document.body.removeChild(fakeEle);
  }
  return retVal;
}

export { computeWidth };
//# sourceMappingURL=compute-width.esm.js.map
